import React, { useState, useEffect } from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import { SortDescNumberIcon, SortAscNumberIcon, SortDescAlphabeticalIcon, SortAscAlphabeticalIcon } from 'ui-component/custom-icons/icons';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import * as XLSX from 'xlsx';

// ✅ Clear
const ProductsStatsComponent = ({ details, isLoading }) => {
	const [data, setData] = useState([])
	const [sortBy, setSortBy] = useState('total_quantity')
	const [sortOrder, setSortOrder] = useState('desc')
	const [isLoadingData, setIsLoadingData] = useState(true)

	useEffect(() => {
		if (details) {
			setData(details);
		}
	}, [details])

	useEffect(() => {
		if (!isLoading) {
			setIsLoadingData(true);
		}
		let sorted = [...details ?? []];
		if (sortBy === 'product_name') {
			sorted.sort((a, b) => {
				const nameA = a.product_name || '';
				const nameB = b.product_name || '';
				if (sortOrder === 'asc') {
					return nameA.localeCompare(nameB);
				} else {
					return nameB.localeCompare(nameA);
				}
			});
		} else if (sortBy === 'total_quantity') {
			sorted.sort((a, b) => {
				if (sortOrder === 'asc') {
					return parseInt(a.quantity) - parseInt(b.quantity);
				} else {
					return parseInt(b.quantity) - parseInt(a.quantity);
				}
			});
		}
		setData(sorted);
		if (!isLoading) {
			setTimeout(() => {
				setIsLoadingData(false);
			}, 300);
		}
	}, [sortBy, sortOrder])

	useEffect(() => {
		setIsLoadingData(isLoading)
	}, [isLoading])

	const s2ab = (s) => {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	};

	const download = () => {
		const wb = XLSX.utils.book_new();
		// Create a worksheet
		const ws = XLSX.utils.json_to_sheet(details);
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		// Convert the workbook to a binary string
		const wbBinaryString = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

		// Convert the binary string to a Blob
		const blob = new Blob([s2ab(wbBinaryString)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

		saveAs(blob, `Projectmix Top Selling Products.xlsx`);
	}

	return (
		<div className="card" style={{ height: '280px' }}>
			<div className="card-body fw-600" style={{ padding: '15px', zIndex: '1000' }}>
				<div className="flex justify-content-between">
					<div className="text-lg fw-500">
						Selling Products
					</div>
					<div className="flex gap-1 absolute" style={{ right: '20px', top: '6px' }}>
						{
							isLoading ? (
								<div className="" style={{ width: '100px', marginTop: '8px' }}>
									<Skeleton variant="rounded" width={'100%'} height={20} className={`rounded-full`} style={{ borderRadius: '32px' }} />
								</div>
							) : (
								<>
									<div
										className="widget-action-icon-container"
										onClick={() => {
											download();
										}}
									>
										<Tooltip title="Export" arrow placement="top">

											<div
												href="javascript:void(0);"
												className="text-black cursor-pointer"
											>

												<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} />
											</div>
										</Tooltip>
									</div>
									<div
										className={`widget-action-icon-container-2 ${sortBy === 'product_name' ? 'active' : '' }`}
										onClick={() => {
											setSortBy('product_name')
											setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
										}}
									>
										<Tooltip title="Sort by Product" arrow placement="top">

											<div
												href="javascript:void(0);"
												className="widget-action-icon cursor-pointer"
											>
												{
													sortBy === 'product_name' ? (
														sortOrder === 'asc' ? (
															<SortAscAlphabeticalIcon height='15px' width='15px' />
														) : (
															<SortDescAlphabeticalIcon height='15px' width='15px' />
														)
													) : (
														<SortDescAlphabeticalIcon height='15px' width='15px' />
													)
												}
											</div>
										</Tooltip>
									</div>
									<div
										className={`widget-action-icon-container-2 ${sortBy === 'total_quantity' ? 'active' : '' }`}
										onClick={() => {
											setSortBy('total_quantity')
											setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
										}}
									>
										<Tooltip title="Sort by Quantity" arrow placement="top">
											<div
												href="javascript:void(0);"
												className="widget-action-icon cursor-pointer"
											>

												{
													sortBy === 'product_name' ? (
														<SortDescNumberIcon height='15px' width='15px' />
													) : (
														sortOrder === 'asc' ? (
															<SortAscNumberIcon height='15px' width='15px' />
														) : (
															<SortDescNumberIcon height='15px' width='15px' />
														)
													)
												}
											</div>
										</Tooltip>
									</div>
								</>
							)
						}
					</div>
				</div>
				<div className="overflow-y-auto custom-scrollbar" style={{ maxHeight: '230px', margin: '10px 0' }}>
					{
						(!isLoading && !isLoadingData) ? (
							data?.length > 0 ? (
								data?.map((item, index) => (
									item?.product_name && (
										<div key={index} className="w-full flex justify-between items-center" style={{ padding: '5px 0' }}>
											<div className="font-normal">
												{item?.product_name}
											</div>
											<div className="ml-auto text-right" style={{ marginRight: '10px'}}>
												{parseInt(item?.quantity)?.toLocaleString()}
											</div>
										</div>
									)
								))
							) : (
								<div className="row" style={{ padding: '5px 0' }}>
									<div className="col-12 text-gray-500">
										No data found
									</div>
								</div>
							)
						) : (
							[...Array(50)].map((e, i) => (
								<div key={i} className="row" style={{ padding: '5px 0' }}>
									<div className="col-12">
										<Skeleton variant="rounded" width={'100%'} height={15} className={`rounded-full`} style={{ borderRadius: '32px' }} />
									</div>
								</div>
							))
						)
					}

				</div>
			</div>
		</div>
	)
}


export default ProductsStatsComponent;